import React from "react";

/**
 * The one back button for every studio page: a small white square with a chevron, in the top bar
 * left of the page title (same look as the product page's icon buttons).
 */
const BackButton = (props: any) => {
  return (
    <svg
      className="cursor-pointer hkp-back-button"
      onClick={() => {
        if (props.name === "createProduct") props.onClick();
      }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Back"
      role="img"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="7.5" fill="#fff" stroke="#e8e8ed" />
      <path d="M18.5 10 12.5 16l6 6" stroke="#1d1d1f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default BackButton;
